import { render } from "./AppCard.vue?vue&type=template&id=20316fee&scoped=true"
import script from "./AppCard.vue?vue&type=script&lang=js"
export * from "./AppCard.vue?vue&type=script&lang=js"

import "./AppCard.vue?vue&type=style&index=0&id=20316fee&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20316fee"]])

export default __exports__